import { render, staticRenderFns } from "./BulkSendBookingInvites.vue?vue&type=template&id=0a3d5984&scoped=true&"
import script from "./BulkSendBookingInvites.vue?vue&type=script&lang=js&"
export * from "./BulkSendBookingInvites.vue?vue&type=script&lang=js&"
import style0 from "./BulkSendBookingInvites.vue?vue&type=style&index=0&id=0a3d5984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d5984",
  null
  
)

export default component.exports